import { render, staticRenderFns } from "./AxFilesystemTreeProjects.vue?vue&type=template&id=2cfaad18&scoped=true&"
import script from "./AxFilesystemTreeProjects.vue?vue&type=script&lang=ts&"
export * from "./AxFilesystemTreeProjects.vue?vue&type=script&lang=ts&"
import style0 from "./AxFilesystemTreeProjects.vue?vue&type=style&index=0&id=2cfaad18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfaad18",
  null
  
)

export default component.exports